import { SVGAssets } from '@business/assets/vectors';
import { useTranslation } from 'react-i18next';
import { signOutHandler } from '@utils/helpers/lib/login';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { routePaths } from '@utils/constants/routePaths';
import { useUserDetailsByUserIdQuery } from '@ports/internal-services/userDetails/userDetailsSlice';
import { useEffect } from 'react';
import { getFirstLogin } from '@ports/common/authStateSlice';
import { Button } from '../Button';
import { Avatar } from '../Avatar';

export const Header = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFirstLogin = useSelector(getFirstLogin);

  const { data: userDetails, refetch } = useUserDetailsByUserIdQuery({} as any);

  useEffect(() => {
    refetch();
  }, []);

  const userName = userDetails?.data?.firstName;
  const email = userDetails?.data?.email;
  const fullName =
    userDetails?.data?.firstName + ' ' + userDetails?.data?.lastName;

  const dropdownItems = [
    {
      label: t('logout'),
      onClick: () => signOutHandler(dispatch, navigate),
      decorator: <SVGAssets.LogoutIcon className="w-5 h-5 mr-2" />
    }
  ];

  return (
    <header className="flex-shrink-0 bg-white shadow-sm z-50">
      <div className="max-w-full mx-auto px-2 sm:px-4 lg:px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-4">
            <SVGAssets.HeaderLogo className="h-12" />
          </div>
          <div className="relative group">
            <div className="flex items-center cursor-pointer">
              <Avatar
                alt={`${userName}`}
                className="w-10 h-10 overflow-hidden rounded-full"
                src={userDetails?.data?.profileImage}
                isHeader={true}
              />

              <SVGAssets.PricingArrow className="w-2 -rotate-90 ml-2" />
            </div>

            <ul
              className="hidden group-hover:block absolute right-0 z-50 shadow-lg bg-white rounded-lg w-82 py-2 border border-gray-100 hover:block"
              id="sideNav">
              <li className="flex items-center gap-3 p-3">
                <Avatar
                  alt={`${userName}`}
                  className="w-20 h-20 overflow-hidden rounded-full"
                  src={userDetails?.data?.profileImage}
                  isHeader={true}
                />
                <div className="flex flex-col">
                  <div className="flex items-center gap-1">
                    <span className="text-[15px] font-semibold text-[#3F602B]">
                      {fullName}
                    </span>
                    {!isFirstLogin && (
                      <Button
                        btnStyle="link"
                        href={routePaths.EditProfile}
                        className="p-0">
                        <SVGAssets.ProfileEditIcon className="w-4 h-4" />
                      </Button>
                    )}
                  </div>
                  <span className="text-xs text-[#8D8D8D] w-50 w-full mb-3">
                    {email}
                  </span>
                  {!isFirstLogin && (
                    <Button
                      btnStyle="link"
                      href={routePaths.MyProfile}
                      className="text-[13px] text-[#6B6B6B] mt-1">
                      {t('accountSettings')}
                    </Button>
                  )}
                </div>
              </li>

              {dropdownItems.map((item, index) => (
                <li
                  key={index}
                  className="w-full flex items-center bg-[#F9FEE9] px-4 py-2 hover:bg-[#ebe5e5]">
                  <span>{item?.decorator}</span>
                  <Button
                    btnStyle="link"
                    className="text-[#49712B]font-normal text-sm py-2 px-4 w-full text-left"
                    onClick={item.onClick}>
                    {item?.label}
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};
